import React from 'react';
import { connect } from 'react-redux';

const PixDiscountTag = (props) => {
  const pixDiscount = React.useMemo(() => {
    if (props.paymentMethods && props.paymentMethods.length > 0) {
      const pixPayment = props.paymentMethods.find((method) => method.slug === 'pix');
      if (pixPayment && pixPayment.discount > 0) {
        return pixPayment.discount;
      }
    }
    return 5;
  }, [props.paymentMethods]);

  return (
    <div className="pix-discount-tag" style={{ color: props.color }}>
      {props.isMobile ? (
        <React.Fragment>
          <img src="/assets/images/icons/tags/pixDiscountMobile.svg" alt="pix" />
          <span>no PIX</span>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <img src="/assets/images/icons/tags/pixDiscount.svg" alt="pix" />
          <span>{pixDiscount}% off no PIX</span>
        </React.Fragment>
      )}
    </div>
  );
};

export default connect((state) => ({
  paymentMethods: state.purchase.paymentMethods,
}))(PixDiscountTag);



// WEBPACK FOOTER //
// ./src/components/search/plans_table/PixDiscountTag.jsx